import React, { useState } from "react"

import { ContactUsModal } from "./contactUsModal"
import { Link } from "gatsby"
import Logo from '../images/new-logo.svg'
import Navbar from "./navbar/navbar.js"

const Header = () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <div className="relative z-50 flex-shrink-0 pb-6 bg-nav-primary lg:pb-0">
      <div className="px-5 mx-auto max-w-screen-2xl lg:px-0 md:max-w-2xl lg:max-w-7xl lg:px-5 xl:px-0 xl:max-w-7xl 2xl:max-w-screen-2xl">
        <div
          className="relative flex items-center justify-between py-0 pt-6 space-x-5 lg:mx-auto"
        >
          <Link className="ml-10 xl:mr-20 lg:ml-0" to="/">
            <img src={Logo} alt="logo" />
          </Link>
          <div className="flex flex-row items-center">
            <Navbar {...{ setShowModal }} />
            <button
              className="hidden px-8 py-2 font-bold text-white rounded bg-black text-l w-content lg:block min-width-max-content mr-4"
              onClick={() =>  window.location.href=`${process.env.GATSBY_USER_PANEL_URL}/auth/signup`}
            >
              Sign up
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="hidden px-8 py-2 font-bold text-white rounded bg-primary text-l w-content lg:block min-width-max-content"
            >
              Book a demo
            </button>
          </div>
        </div>
        {showModal &&
          <ContactUsModal
            showModal={showModal}
            setShowModal={setShowModal}
            headline={`Are you ready to gain more insight into your marketing data?<br/><br/>
            Book a demo with our team to get a personalized tour of our platform and take the opportunity to get a free trial using two weeks' worth of your data after the demo.<br/><br/>
            If you cannot find a time slot that suits you here, feel free to send us an email with your availabilities at <a class='underline' href='mailto:info@growthfullstack.com'>info@growthfullstack.com</a>, and we will get back to you ASAP.`}
            btnText="Book a Demo"
            subject="Demo Request"
          /> }
      </div>
    </div>
  )
}

export default Header
